import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal} from "antd";
import {t} from "i18next";
import {generateUUID2, getFileNameWithoutExt, isStringNullOrEmpty, isSupportVideoAnnoUrl, isYoutubeUrl} from "@/utils";
import {isValidUrl, isValidUrlHttps} from "../../../@excalidraw/packages/excalidraw/data/url";
import {getLibraryByFileName, updateCard} from "@model/card";
import {postMessage} from "@/common/event";
import {EVENT_OPEN_LIBRARY_ITEM, EVENT_REFRESH_LIBRARY_LIST} from "@/Const";
import {fetchWeblink} from "../../../@excalidraw/packages/excalidraw/element/cardLink";
import {ipcSend} from "@/common/ipc";

const DialogWeblinkImport = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const [inputUrl,setInputUrl] = useState('');
    const inputRef = useRef(null);
    const mCallback = useRef(null);

    const onShowDialog = (callback)=>{
        mCallback.current = callback;
        setIsShowDialog(true);
    }

    useEffect(()=>{
        setTimeout(()=>{
            inputRef.current?.focus();
        },100)
    },[])

    /**
     * 添加到库...
     */
    const addToLibrary = async ()=>{
        window.showProgress(t("Importing"));
        fetchWeblink(inputUrl).then(async (res:any)=>{
            const item = {
                ...res,
                id:generateUUID2(),
                name:res.title,
                fileName:inputUrl,
                type:'webLink',
                thumbImage:res.image,
                createTime:Date.now(),
                isAbsolutePath:false,
            }
            await updateCard(item);

            window.closeProgress();
            props.onCloseCallback();

            if (mCallback.current){
                mCallback.current(item);
            }else{
                window.onShowMessageTip(t("Import complete"),()=>{
                    //转到library
                    ipcSend('open-url',inputUrl);
                })
            }

            //刷新列表
            postMessage(EVENT_REFRESH_LIBRARY_LIST);
        })
    }

    return <Modal width={520} zIndex={2005}
                  afterClose={() => {
                      props.onCloseCallback();
                  }}
                  open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      setIsShowDialog(false)
                  }}>
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                <span className={'dialog-title-large'}>{t('Import weblink')}</span>
                <div style={{flexGrow: '1'}}/>
            </div>
            <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>
            <span className={'dialog-title'}>{t("Weblink URL")}</span>
            <input ref={inputRef} className={'input-border-5f mt-8'} value={inputUrl} placeholder={"https://example.com"} onInput={(e)=>{
                setInputUrl(e.currentTarget.value)
            }}/>

            <div className={'flex-center mt-32 mb-4'}>
                <Button
                    style={{height: '34px', minWidth: '120px'}}
                    className='large-w-button button-border-gray-style font-size-14 font-family-medium'
                    onClick={() => {
                        setIsShowDialog(false);
                    }}>{t("Cancel")}</Button>
                <Button
                    disabled={!isValidUrlHttps(inputUrl)}
                    className='large-w-button button-solid-style font-size-14 font-family-medium'
                    type="primary"
                    onClick={async () => {
                        //检测url是否存在.
                        getLibraryByFileName(inputUrl).then(res=>{
                            if (res){
                                // message.info(t('LinkExist'));
                                window.showMessageTip(t("LinkExist"),t("View"),"",()=>{
                                    postMessage(EVENT_OPEN_LIBRARY_ITEM,{...res});
                                    if (props.onCloseCallback){
                                        props.onCloseCallback();
                                    }
                                    window.closeMessageTip();
                                })
                            }else{
                                if (isSupportVideoAnnoUrl(inputUrl)) {
                                    window.createUrlNewLibraryItem(inputUrl).then(data=>{
                                        if (isYoutubeUrl(inputUrl)){
                                            postMessage(EVENT_OPEN_LIBRARY_ITEM,{...data});
                                        }else{
                                            window.onShowMessageTip(t("Import complete"),()=>{
                                                //转到library
                                                window.showLibraryFilePreview(data);
                                            })
                                        }
                                    });
                                    props.onCloseCallback();
                                }else {
                                    addToLibrary();
                                }
                            }
                        })
                    }}
                    style={{
                        marginLeft: '12px',
                        minWidth: '120px'
                    }}
                    htmlType={"submit"}>{t("Import")}</Button>
            </div>
        </div>
    </Modal>
})

export default DialogWeblinkImport;






































































































































